<template>
  <hr :style="{ border: `${field.borderWidth}px ${field.borderStyle} ${field.borderColor}` }" />
</template>

<script setup lang="ts">
interface Props {
  settings: Record<string, any>
  parentField?: Record<string, any>
  field: Record<string, any>
}

defineProps<Props>()
</script>
